export const initialOrderFilter = {
  PageNumber: 1,
  PageSize: 25,
  SortByColumn: 'byDate',
  SortType: 'descending',
  IncludeRefunds: true,
  TicketTypeIds: [],
  DateId: '',
  DateFrom: '',
  DateTo: '',
  id: '',
  filter: '',
};

export type OrdersFilterType = {
  PageNumber?: number;
  PageSize?: number;
  SortByColumn?: string;
  SortType?: string;
  IncludeRefunds?: boolean;
  TicketTypeIds?: string[];
  DateId?: string;
  id?: string;
  DateFrom?: string;
  DateTo?: string;
  filter?: string;
};
